export class LoadFiltersFailureAction {
    public static readonly type = '[JobsPlacements] Load filters failure';
}
